"use client";

import { FC } from "react";
import ScrollUp from "components/atoms/ScrollUp";
import AboutSectionOne from "components/molecules/AboutSection";
import AboutSectionTwo from "components/molecules/AboutSectionTwo";
import Pricing from "components/molecules/Pricing";
import { aboutSectionSaveContent, aboutSectionSaveImages, aboutSectionShareContent, aboutSectionShareImages } from "utils/landingText";
import * as Styled from "./PricingLanding.styled";
export const PricingLanding: FC = () => {
  return <Styled.Main suppressHydrationWarning data-sentry-element="unknown" data-sentry-component="PricingLanding" data-sentry-source-file="index.tsx">
            <ScrollUp data-sentry-element="ScrollUp" data-sentry-source-file="index.tsx" />
            <Pricing isHeading={true} data-sentry-element="Pricing" data-sentry-source-file="index.tsx" />
            <AboutSectionOne data-sentry-element="AboutSectionOne" data-sentry-source-file="index.tsx" />
            <AboutSectionTwo id="about-4" images={aboutSectionSaveImages} content={aboutSectionSaveContent} data-sentry-element="AboutSectionTwo" data-sentry-source-file="index.tsx" />
            <AboutSectionTwo id="about-2" images={aboutSectionShareImages} content={aboutSectionShareContent} data-sentry-element="AboutSectionTwo" data-sentry-source-file="index.tsx" />
        </Styled.Main>;
};